import React from 'react';
import Modal from 'react-modal';

export default (props) => (
    <div>
        <Modal
            className="Modal successModal"
            isOpen={props.success}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={this.closeModal}
            overlayClassName="Overlay"
            contentLabel="Example Modal"
        >
            <h2>Success!</h2>
            <p>{props.successMsg}</p>
            <button onClick={props.onClose}>OK</button>
        </Modal>
    </div>
);



// WEBPACK FOOTER //
// ./src/Components/tertiarySuccessModal.js